@if (commandTemplate(); as template) {
  <nx-edit-tipTap-input
    (isEmptyChange)="onEmptyStateChange($event)"
    [placeholder]="'Kommentar eingeben...'"
    [ngModel]="text()"
    (ngModelChange)="text.set($event)">
  </nx-edit-tipTap-input>
  <div class="mt-2">
    <nx-default-button
        [style]="'dark'"
        [disabled]="isEditorEmpty()"
        (click)="save()"
        [label]="template.settings?.label">
    </nx-default-button>
  </div>
} @else if (owner() && !hasCreatePermission) {
  <div class="text-base text-gray-400 border border-dashed border-gray-300 rounded-md p-4 flex flex-col items-center justify-center min-h-[74px] text-center">
    <span>Du kannst keine Kommentare erstellen? Durch ein kürzliches Update werden die Rollen & Rechte für Aktivitäten benötigt.</span>
    <a href="https://docs.nexcore.de/changelog#rollen-and-rechte" target="_blank" class="text-primary underline hover:text-primary-dark mt-1">Erfahre hier, wie du die Berechtigung erhältst.</a>
  </div>
}